export default {
    created() {
        this.$on("reload", () => {
            for (var ch = 0; ch < this.$children.length; ch++) {
                this.$children[ch].$emit("reload");
            }
        });
    }
}